import Vue from 'vue';
import api from '@/apis/Api';
import siteChangeManager from '@/utils/siteChangeManager';
import i18n from '@/plugins/i18n';
import { get } from 'ol/proj';
import { recordSyncIntent, SyncReason, nextPipelineCorrelationId } from '@/map/reportDefectPipeline';
import { appPerfMark, appPerfMeasure, appPerfSinceMyProfile } from '@/utils/appBootstrapPerfLog.js';
const state = {
  p: [], // 선택된 프로젝트 ID 배열
  s: [], // 선택된 사이트 ID 배열
  d: [], // 선택된 고유 day 값(s.id_d.name) 배열
  site: [], // 현재 사이트 정보
  report: undefined, // 현재 리포트
  cacheReportId: undefined, //기존의 reportId 뒤로가기한 경우에도 지우지 않음, 창닫았을때는 지움 beforeDestory에서 지움?
  thermalImageChanged: false,
  showExplorer: true,
  mapMenu: false,
  reportSelectTaskComplete: false //watch -> getDefectSummary api 실행
};

const getters = {
  // 한 리스트의 active여부에 대한 판단
  isActive: (state) => (projectId, siteId, dayName, reportId) => {
    // console.log("isActive:", projectId, siteId, dayName, reportId, state);
    const dayKeyFormatted = '';
    // console.log("isActive:", projectId, siteId, dayName, reportId);
    if (siteId && dayName) {
      // console.log('isActive', state);
      const dayKeyFormatted = `${siteId}_${dayName}`;
      siteId = '';
      return state.d.includes(dayKeyFormatted);
    }

    if (projectId) {
      return state.p.includes(projectId);
    }

    if (siteId) {
      // console.log("siteId",siteId, state.s.includes(siteId));
      return state.s.includes(siteId);
    }

    if (reportId) {
      return state?.report?.id == reportId;
    } else return false;
  },
  getReportId: (state) => {
    if (state?.report?.id) return state.report.id;
    else return undefined;
  },
  getReportName: (state) => {
    return state?.report?.name ?? '';
  },
  getSite: (state) => {
    return state.site;
  },
  getReport: (state) => {
    return state.report;
  },
  getShowExplorer: (state) => {
    return state.showExplorer;
  },
  getMapMenu: (state) => {
    return state.mapMenu;
  },
  getReportSelectTaskComplete: (state) => {
    return state.reportSelectTaskComplete;
  },
  getCacheReportId: (state) => {
    return state.cacheReportId;
  },
  getSiteName: (state) => {
    console.log('테스트 getSiteName', state?.site);
    return state?.site?.name;
  }
};

const mutations = {
  // 활성화 또는 비활성화 처리
  TOGGLE_ACTIVE(state, { projectId, siteId, dayName, reportId }) {
    console.log('TOGGLE_ACTIVE', projectId, siteId, dayName, reportId, state);
    //아래 4가지 처리중 하나만 처리하고 return
    // day 처리
    if (siteId && dayName?.length > 0) {
      console.log('테스트 day처리', siteId, dayName);
      const dayKeyFormatted = `${siteId}_${dayName}`;
      if (state.d.includes(dayKeyFormatted)) {
        Vue.set(
          state,
          'd',
          state.d.filter((key) => key !== dayKeyFormatted)
        );
      } else {
        Vue.set(state.d, state.d.length, dayKeyFormatted);
      }
      return;
    }

    // project 처리
    if (projectId) {
      console.log('테스트 project처리', projectId);
      if (state.p.includes(projectId)) {
        Vue.set(
          state,
          'p',
          state.p.filter((id) => id !== projectId)
        );
      } else {
        Vue.set(state.p, state.p.length, projectId);
      }
      return;
    }

    // site 처리
    if (siteId) {
      console.log('테스트 site처리', siteId);
      if (state.s.includes(siteId)) {
        Vue.set(
          state,
          's',
          state.s.filter((id) => id !== siteId)
        );
      } else {
        Vue.set(state.s, state.s.length, siteId);
      }
      return;
    }

    // report 처리
    if (reportId) {
      console.log('테스트 report처리', reportId);
      // if (state.reportId.includes(reportId)) {
      //   Vue.set(state, 'r', state.reportId.filter(id => id !== reportId));
      // } else {
      //   Vue.set(state.reportId, state.reportId.length, reportId);
      // }
      if (!state.report) {
        state.report = {};
      }
      // report 객체가 이미 존재하지만 ID가 다른 경우 업데이트 (reportId가 있는경우)
      if (state?.report?.id !== reportId) {
        Vue.set(state.report, 'id', reportId);
      } else if (state.report.id === reportId) {
        // 같은 reportId인 경우 undefined로 설정하여 비활성화
        Vue.set(state.report, 'id', undefined);
      }
    }
    console.log('테스트 toggleActive', state);
  },
  SET_REPORT_NAME(state, reportName) {
    // console.log('SET_REPORT_NAME', reportName);
    if (!state.report) state.report = {};
    Vue.set(state.report, 'name', reportName);
  },
  SET_SITE(state, site) {
    Vue.set(state, 'site', site);
    state.site = site;
  },
  RESET_STATE(state) {
    Vue.set(state, 'p', []);
    Vue.set(state, 's', []);
    Vue.set(state, 'd', []);
    Vue.set(state, 'site', []);
    Vue.set(state, 'report', undefined);
  },
  SET_REPORT(state, report) {
    Vue.set(state, 'report', report);
  },
  SET_SHOW_EXPLORER(state, showExplorer) {
    console.log('테스트 SET_SHOW_EXPLORER', showExplorer);
    Vue.set(state, 'showExplorer', showExplorer);
  },
  SET_MAP_MENU(state, mapMenu) {
    Vue.set(state, 'mapMenu', mapMenu);
  },
  SET_REPORT_ID(state, reportId) {
    if (!state.report) state.report = {};
    Vue.set(state.report, 'id', reportId);
  },
  SET_REPORT_SELECT_TASK_COMPLETE(state, reportSelectTaskComplete) {
    Vue.set(state, 'reportSelectTaskComplete', reportSelectTaskComplete);
  },
  SET_CACHE_REPORT_ID(state, cacheReportId) {
    Vue.set(state, 'cacheReportId', cacheReportId);
  }
};

const actions = {
  toggleActive({ commit }, { projectId, siteId, dayName, reportId }) {
    // console.log('toggleActive', projectId, siteId, dayName, reportId);
    commit('TOGGLE_ACTIVE', { projectId, siteId, dayName, reportId });
  },
  async selectSite({ commit, getters, rootState, dispatch }, site) {
    //site 선택후 해당 사이트로 지도만 이동
    //해당 site 탭이 닫혀있었을 떄 -> site의 위치로 이동
    if (!rootState.explorer.s.includes(site.id)) {
      const siteResp = await api.read(`/sites/${site.id}`);
      console.log('테스트 selectSite', siteResp?.data?.content);
      commit('SET_SITE', siteResp?.data?.content);
      // 사이트 클릭으로 인한 변경 처리
      await siteChangeManager.handleSiteClick(siteResp?.data?.content);
    }
    commit('TOGGLE_ACTIVE', {
      projectId: '',
      siteId: site.id,
      dayName: '',
      reportId: ''
    });
  },
  /**
   * 선택한 report항목으로 이동전 api 처리 후 이동 =>thermalImage watch로 이어서 다른 코드가 전개됨
   * @param {site} site ->site전체 사용
   * @param {report} item-> item.id, item.name만 사용
   * @returns
   */
  async selectTreeItem(
    { commit, getters, rootState, dispatch },
    { site, item, preloadedReport }
  ) {
    appPerfMark('explorer:selectTreeItem:start', {
      reportId: item?.id,
      preloadedReport: preloadedReport != null
    });
    appPerfSinceMyProfile('explorer:selectTreeItem:start', { reportId: item?.id });
    console.log('테스트 selectTreeItem', item);
    console.log('테스트 selectTreeItem', site);
    commit('SET_REPORT_ID', item?.id);
    commit('SET_REPORT_NAME', item?.name);
    commit('SET_SITE', site);

    if (
      item?.id != null &&
      String(rootState.dashboard?.wfsDefectRowsReportId) !== String(item.id)
    ) {
      commit('dashboard/clearWfsDefectRows', null, { root: true });
    }

    //thermal watch를 통해 showExplorer가 false(정밀검사보고가 열림)이므로 구분하여 처리
    let runThermalApi = false;
    let promiseGetThermalImages = null;
    const thermalImages = rootState.dashboard.thermalImages;

    try {
      promiseGetThermalImages = dispatch(
        'dashboard/fetchThermalImages',
        {
          reportId: item?.id
        },
        { root: true }
      );
      runThermalApi = true;

      //api 결과 받은 후에 페이지 이동
      //thermalApi를 호출한 경우-> thermalImages watch로 변경된 경우 정밀검사보고로 이동
      //thermalApi를 호출하지 않은 경우 -> 아래 Api 호출 이후에 정밀검사보고로 이동
      // CoreLeftDrawer mounted 등에서 이미 GET /solarExamineReports/{id} 한 경우 중복 요청 방지
      const reportData =
        preloadedReport != null
          ? preloadedReport
          : (await api.getApiResource('/solarExamineReports/' + item?.id))?.data;
      console.log('테스트 report resp', reportData);
      commit('SET_REPORT', reportData);
      // 안전한 체이닝으로 사이트 ID 추출
      const siteId = reportData?._embedded?.site?.id;
      if (!siteId) {
        throw new Error(i18n.t('common.reportSiteNotFound'));
      }
      
      const siteResp = await api.read(`/sites/${siteId}`);
      console.log('테스트 resp', siteResp);
      commit('SET_SITE', siteResp?.data?.content);
      // (주의)사이트로 이동한 후에 defect 정보를 지도에 표시해야 한다.
      // 그렇지 않으면 defect 정보가 지워진다.
      // watch mapMenu -> defect filters 초기화
      // 이 초기화는 watch의 defecFilters를 trigger하여 GeoServer에서 defect정보를 가져오도록 한다.

      await promiseGetThermalImages;

      // 네비게이션으로 인한 사이트 변경 처리
      await siteChangeManager.handleSiteNavigation(siteResp?.data?.content);
      // moveSite 가 defectFeature 레이어를 제거만 하고 다시 붙이지 않음.
      // DotSolarMapBox.loadDefectMarkers 가 먼저 끝난 뒤 selectTreeItem 이 끝나면 결함 아이콘이 사라진 채로 남음 → WFS 재부착.
      const correlationId = nextPipelineCorrelationId();
      recordSyncIntent({
        reportId: item?.id,
        reason: SyncReason.STORE_EXPLORER_SELECT_TREE,
        source: 'explorer.selectTreeItem.beforeRequestMapRefresh',
        extra: { siteId, correlationId }
      });
      await dispatch('defect/completeMapRefresh', null, { root: true });
      await dispatch(
        'defect/requestMapRefresh',
        {
          correlationId,
          source: 'explorer.selectTreeItem',
          reason: 'afterSiteNavigation'
        },
        { root: true }
      );
      //report 탐색기 열는 것은 thermalImages watch로 처리
      //thermalApi 호출안한경우 바로 정밀검사보고로 이동
    } catch (e) {
      console.error(e);
      runThermalApi = false;
    }

    //지도관련 ui 상태변경 및 SET_REPORT_SELECT_TASK_COMPLETE의 watch로 getDefectSummary api 실행, cache reportId 값 할당
    commit('SET_MAP_MENU', true);
    commit('SET_SHOW_EXPLORER', false);
    console.log(
      '테스트 setReportSelectTaskComplete',
      getters.getReportSelectTaskComplete
    );
    commit('SET_REPORT_SELECT_TASK_COMPLETE', true);
    commit('SET_CACHE_REPORT_ID', item.id);

    appPerfMeasure('explorer:selectTreeItem:done', 'explorer:selectTreeItem:start', {
      reportId: item?.id,
      runThermalApi
    });
    appPerfSinceMyProfile('explorer:selectTreeItem:done');
    return true; // loading ui 해제
  },
  setSite({ commit }, site) {
    commit('SET_SITE', site);
  },
  setReportName({ commit }, reportName) {
    // console.log("reportName", reportName);
    commit('SET_REPORT_NAME', reportName);
  },
  resetState({ commit }) {
    commit('RESET_STATE');
  },
  setReport({ commit }, report) {
    commit('SET_REPORT', report);
  },
  setShowExplorer({ commit }, showExplorer) {
    commit('SET_SHOW_EXPLORER', showExplorer);
  },
  setMapMenu({ commit }, mapMenu) {
    commit('SET_MAP_MENU', mapMenu);
  },
  setReportSelectTaskComplete({ commit }, reportSelectTaskComplete) {
    commit('SET_REPORT_SELECT_TASK_COMPLETE', reportSelectTaskComplete);
  },
  setReportIdAndResetDefectRect({ commit, rootState, dispatch }, reportId) {
    const oldReportId = rootState.explorer?.report?.id;
    const isReportChanged = oldReportId !== reportId;
    commit('SET_REPORT_ID', reportId);
    if (isReportChanged && oldReportId) {
      dispatch('defect/resetDefectRect', null, { root: true });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
